<template>
  <div>
    <Cargando v-if="isLoading"></Cargando>
    <div v-else-if="errorBanner" class="bg-red-50 border-l-4 border-red-400 p-4 mb-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm text-red-700">
            {{ errorBanner }}
          </p>
          <div class="mt-2 text-sm text-red-700">
            <p>Por favor, envía un correo a <a href="mailto:nacho@orsai.org"
                class="font-medium underline">nacho@orsai.org</a> o <a href="mailto:comunidad@orsai.org"
                class="font-medium underline">comunidad@orsai.org</a> con el siguiente código de error:</p>
            <p class="mt-1 font-mono text-xs">{{ errorCode }}</p>
          </div>
        </div>
      </div>
    </div>
    <FormKit v-else-if="estaEditando" type="form" @submit="handleSubmit" v-model="valores">
      <FormKitSchema :schema="computedFormSchema" />
      <template #submit>
        <div class="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400 gap-3">
          <div>
            {{ submitText }}
          </div>
          <button type="submit"
            class="bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded w-full md:w-auto">
            Guardar
          </button>
        </div>
      </template>
    </FormKit>

    <div v-else>
      <div class="border-t border-gray-200 pt-4 cuento orsai-serif relative">
        <button v-if="valores.id" @click="compartirHistoria"
          class="absolute top-0 right-0 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded flex items-center gap-2 text-sm font-inter transition-all duration-300"
          :class="{ 'bg-green-600 hover:bg-green-700': copiado }">
          <svg v-if="!copiado" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20"
            fill="currentColor">
            <path
              d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd" />
          </svg>
          {{ copiado ? 'Copiado' : 'Compartir' }}
        </button>

        <div class="flex items-center text-xs gap-2 border-white border rounded-full inline mb-4">
          <button @click="cambiarVersion(1)" class="px-3 py-1 rounded-l-full" :class="{
            'bg-black text-white': versionSeleccionada === 1,
            'text-gray-300': versionSeleccionada !== 1
          }">
            VERSIÓN 1
          </button>
          <button @click="cambiarVersion(2)" class="px-3 py-1" :class="{
            'bg-black text-white': versionSeleccionada === 2,
            'text-gray-300': versionSeleccionada !== 2
          }">
            VERSIÓN 2
          </button>
          <button @click="cambiarVersion(3)" class="px-3 py-1" :class="{
            'bg-black text-white': versionSeleccionada === 3,
            'text-gray-300': versionSeleccionada !== 3
          }">
            VERSIÓN 3
          </button>
          <button @click="cambiarVersion('actual')" class="px-3 py-1 rounded-r-full" :class="{
            'bg-black text-white': versionSeleccionada === 'actual',
            'text-gray-300': versionSeleccionada !== 'actual'
          }">
            VERSIÓN ACTUAL
          </button>
        </div>

        <div v-if="versionSeleccionada !== 'actual'" class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm text-yellow-700">
                Estás viendo una versión anterior de tu historia. Para editar, selecciona la versión actual.
              </p>
            </div>
          </div>
        </div>

        <h1 v-if="propiedades.titulo && valores.titulo" class="titulo">
          {{ valores.titulo }}
        </h1>
        <div class="resumen leading-snug">
          {{ valores.resumen }}
        </div>

        <!-- Si tiene audio, mostrar el audio (esta en audio_v2) -->
        <div v-if="propiedades.audio && valores.audio_v2" class="mb-4">
          <audio :src="valores.audio_v2" controls class="w-[calc(100%)]"></audio>
        </div>

        <template v-if="propiedades.cuento && getContenidoCuento()">
          <p class="contenido leading-tight mb-3" v-for="parrafo in getContenidoCuento().split('\n')" :key="parrafo">
            {{ parrafo }}
          </p>
        </template>
        <div v-if="!valores || Object.keys(valores).length === 0" class="text-center text-gray-500 py-8">
          No hay datos cargados. Por favor, edita tu historia.
        </div>
      </div>
      <div
        class="flex flex-col md:flex-row items-center text-sm text-gray-200 gap-3 border-t border-gray-300 mt-4 pt-4">
        <div v-if="!propiedades.editable">
          <div class="text-sm text-gray-500 mb-2 md:mb-0">
            La edición de tu historia está cerrada, pero podrás seguir editándola en otra instancia.
          </div>
          <div class="text-sm font-semibold text-gray-800">
            ¡Nos vemos cada domingo a las 15 Hs!
          </div>
        </div>

        <div v-else-if="versionSeleccionada === 'actual'">
          <div class="text-sm text-gray-500 mb-2 md:mb-0">
            {{ submitText }}
          </div>
        </div>

        <button type="submit" @click="estaEditando = true"
          v-if="propiedades.editable && versionSeleccionada === 'actual'"
          class="bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded w-full md:w-auto">
          Editar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { defineComponent, ref, onMounted, computed } from "vue";
import { notify } from "notiwind";
import Cargando from "@/components/escuela/Cargando.vue";
import { useTalleresStore } from "@/stores/talleres";
import { useAuthStore } from "@/stores/auth";
import strapiService from '@/services/strapi';
import * as Sentry from "@sentry/vue";

export default defineComponent({
  name: "CuentoForm",
  components: {
    Cargando,
  },
  props: {
    submitText: {
      type: String,
      default: "Podés cambiar, agregar y modificar tu historia todas las veces que quieras. Cada domingo vamos a cerrar la edición, para poder guardar la versión y luego podrás seguir editando.",
    },
    titulo: {
      type: Boolean,
      default: true,
    },
    tema: {
      type: Boolean,
      default: true,
    },
    resumen: {
      type: Boolean,
      default: true,
    },
    audio: {
      type: Boolean,
      default: true,
    },
    cuento: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const formSchema = ref([]);
    const valores = ref({ cuento: "" });
    const usuario = ref({});
    const isLoading = ref(true);
    const estaEditando = ref(false);
    const propiedades = ref(props);
    const errorBanner = ref(null);
    const errorCode = ref(null);
    const versionSeleccionada = ref('actual');
    const copiado = ref(false);

    const cambiarVersion = (version) => {
      versionSeleccionada.value = version;
      estaEditando.value = false;
    };

    const getContenidoCuento = () => {
      if (versionSeleccionada.value === 'actual') {
        return valores.value.cuento;
      }
      return valores.value[`cuento_semana_${versionSeleccionada.value}`] || '';
    };

    /**
     * Genera un código de error único
     */
    const generateErrorCode = () => {
      return `ERR-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    };

    /**
     * Reporta un error a Sentry con información detallada
     */
    const reportErrorToSentry = (error, context) => {
      const errorCode = generateErrorCode();
      Sentry.withScope((scope) => {
        scope.setExtras({
          errorCode,
          ...context
        });
        Sentry.captureException(error);
      });
      return errorCode;
    };

    /**
     * Valida el número máximo de palabras en un campo de texto
     * @param {Object} node - Nodo del formulario
     * @param {Number} max - Número máximo de palabras permitidas
     * @returns {Boolean} - true si está dentro del límite, false si lo excede
     */
    function maxWords(node, max = 50) {
      let s = node._value;
      if (s === undefined || s === null) return 0;
      s = s.replace(/(^\s*)|(\s*$)/gi, "").replace(/[ ]{2,}/gi, " ").replace(/\n /, "\n");
      return s.split(' ').filter(str => str != "").length <= max;
    }

    /**
     * Obtiene el cuento del alumno para el taller actual
     * Requiere que exista un taller actual y un alumno en el store
     */
    const fetchCuentoUsuario = async () => {
      try {
        const storeTaller = useTalleresStore();
        const tallerActual = storeTaller.tallerActual;
        let alumnoActual = storeTaller.alumnoActual;

        // Validación inicial de taller
        if (!tallerActual?.slug) {
          throw new Error("No hay taller seleccionado");
        }

        // Si no hay alumno, intentamos buscarlo o crearlo
        if (!alumnoActual?.id) {
          try {
            // Primero intentamos buscar el alumno por email
            const alumnoResponse = await strapiService.get(`/api/alumnos?filters[email]=${usuario.value.email}`);
            alumnoActual = alumnoResponse.data[0];

            // Si no existe, reportamos el error
            if (!alumnoActual) {
              const errorContext = {
                email: usuario.value.email,
                nombre: usuario.value.nombre,
                apellido: usuario.value.apellido,
                tallerSlug: tallerActual.slug,
                tallerId: tallerActual.id
              };

              const errorCode = reportErrorToSentry(
                new Error("Alumno no encontrado en el sistema"),
                errorContext
              );

              errorBanner.value = "No encontramos tu registro en el sistema. Esto puede ocurrir si no estás inscripto en el taller actual.";
              errorCode.value = errorCode;
              return;
            }
          } catch (error) {
            const errorCode = reportErrorToSentry(error, {
              email: usuario.value.email,
              tallerSlug: tallerActual.slug
            });

            errorBanner.value = "Hubo un error al buscar tu registro en el sistema.";
            errorCode.value = errorCode;
            return;
          }
        }

        // Buscamos el cuento asociado al alumno y taller
        try {
          const cuentoResponse = await strapiService.get(
            `/api/cuentos?filters[alumno][id]=${alumnoActual.id}&filters[taller][slug]=${tallerActual.slug}&populate=*`
          );

          const cuento = cuentoResponse.data[0];

          if (cuento) {
            valores.value = cuento;
          } else {
            valores.value = {};
          }
        } catch (error) {
          const errorCode = reportErrorToSentry(error, {
            alumnoId: alumnoActual.id,
            tallerSlug: tallerActual.slug
          });

          errorBanner.value = "Hubo un error al cargar tu historia.";
          errorCode.value = errorCode;
        }

      } catch (error) {
        const errorCode = reportErrorToSentry(error, {
          email: usuario.value.email
        });

        errorBanner.value = "Hubo un error inesperado al cargar tu historia.";
        errorCode.value = errorCode;
      }
    };

    /**
     * Obtiene el esquema del modelo Cuento desde Strapi
     * y construye el esquema del formulario dinámicamente
     */
    const fetchSchemaFromStrapi = async () => {
      try {
        const storeTaller = useTalleresStore();
        let schema = storeTaller.schema;
        if (!schema) {
          const response = await strapiService.get(`/api/content-type-builder/content-types`);
          schema = response.data.find((model) => model.uid === "api::cuento.cuento");
          storeTaller.setSchema(schema);
        }

        const tieneCuentoConTitulo = !!valores.value.titulo;

        if (schema) {
          formSchema.value = Object.entries(schema.schema.attributes)
            .filter(([key]) => {
              return props[key] || false;
            })
            .map(([key, value]) => {
              if (key === "audio") {
                return {
                  $formkit: "audio_orsai",
                  name: key,
                  label: "Audio de tu historia",
                  dropzone: true,
                  validation: value.required ? "required" : "",
                  props: {
                    id_cuento: valores.value.id,
                    reload: () => {
                      console.log("audio-updated");
                      estaEditando.value = false;
                      fetchCuentoUsuario();
                    }
                  },
                  help: "Podés subir un archivo de audio en formato mp3, ogg o wav.",
                };
              }
              if (value.type === "string") {
                return {
                  $formkit: "text",
                  name: key,
                  label: formatLabel(key),
                  validation: value.required ? "required" : "",
                  props: { disabled: !props.editable },
                };
              }
              if (value.type === "richtext" || value.type === "text") {
                const maxWordsRule = key === "cuento" ? "300" : "30";
                return {
                  $formkit: "wctextarea",
                  name: key,
                  label: formatLabel(key),
                  props: {
                    minHeight: key === "cuento" ? "20rem" : "",
                    maxWordsRule: maxWordsRule,
                  },
                  validationRules: { maxWords },
                  validation: value.required
                    ? "required|maxWords:" + maxWordsRule
                    : "maxWords:" + maxWordsRule,
                  validationMessages: {
                    maxWords:
                      "Solo puedes escribir hasta " +
                      maxWordsRule +
                      " palabras.",
                  },
                };
              }
              if (value.type === "enumeration") {
                value.enum.unshift({
                  value: null,
                  label: "-- Seleccioná una temática -- ",
                });

                return {
                  $formkit: "select",
                  name: key,
                  label: formatLabel(key),
                  options: value.enum,
                  validation: value.required ? "required" : "",
                };
              }
              return null;
            })
            .filter(Boolean)
            .map((item) => {
              if (item.name === "titulo") {
                return {
                  ...item,
                  disabled: tieneCuentoConTitulo,
                };
              }
              return item;
            })
            .sort((a, b) => {
              const order = ["titulo", "audio", "tema", "resumen", "cuento"];
              return order.indexOf(a.name) - order.indexOf(b.name);
            });
        }
      } catch (error) {
        console.error("Error al obtener el esquema:", error);
      }
    };

    /**
     * Formatea las etiquetas de los campos del formulario
     */
    const formatLabel = (key) => {
      const labels = {
        titulo: "Título de tu historia",
        tema: "¿A qué temática pertenece?",
        cuento: "Tu historia, en 300 palabras",
        audio: "Sube un audio",
      };
      return labels[key] || key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1");
    };

    /**
     * Maneja el envío del formulario
     * Crea un nuevo cuento o actualiza uno existente
     * Establece las relaciones con el taller y el alumno
     */
    const handleSubmit = async (data) => {
      try {
        const filteredData = Object.fromEntries(
          Object.entries(data).filter(([key]) => props[key])
        );

        const storeTaller = useTalleresStore();
        const tallerActual = storeTaller.tallerActual;
        let alumnoActual = storeTaller.alumnoActual;

        // Validaciones
        if (!alumnoActual?.id) {
          // Buscar el alumno por el email
          const res = await strapiService.get(`/api/alumnos?filters[email]=${usuario.value.email}`);
          const alumno = res.data[0];
          alumnoActual = alumno;
        }

        if (!tallerActual?.id) {
          notify({ group: "foo", title: "Error", type: "error", text: "No se pudo obtener el taller actual." });
          return;
        }

        // Crear nuevo cuento o actualizar existente
        if (!valores.value.id) {
          const response = await strapiService.post(`/api/cuentos`, {
            data: {
              ...filteredData,
              taller: {
                connect: [{ id: tallerActual.id }]
              },
              alumno: {
                connect: { id: alumnoActual.id }
              }
            },
          });
          valores.value = response;
        } else {
          await strapiService.put(`/api/cuentos/${valores.value.documentId}`, {
            data: filteredData,
          });
        }

        // Actualizar valores
        valores.value = {
          ...valores.value,
          ...filteredData,
        };

        notify({ group: "foo", title: "¡Listo!", type: "success", text: "Tu historia se guardó correctamente." });
        estaEditando.value = false;
      } catch (error) {
        notify({ group: "foo", title: "Error", type: "error", text: "Hubo un error al guardar tu historia." });
      }
    };

    const compartirHistoria = () => {
      const storeTaller = useTalleresStore();
      const tallerActual = storeTaller.tallerActual;
      console.log("tallerActual", tallerActual);
      const docente = tallerActual.docente.toLowerCase().replace(" ", "-");
      const slugTaller = tallerActual.slug;

      const url = `http://escuela.orsai.org/virtuales/${docente}/${slugTaller}/votar/audios?idCuento=${valores.value.id}`;
      console.log("url", url);

      // Crear un elemento input temporal
      const input = document.createElement('input');
      input.style.position = 'fixed';
      input.style.opacity = 0;
      input.value = url;
      document.body.appendChild(input);

      // Seleccionar y copiar el texto
      input.select();
      input.setSelectionRange(0, 99999); // Para dispositivos móviles

      try {
        document.execCommand('copy');
        copiado.value = true;
        setTimeout(() => {
          copiado.value = false;
        }, 2000);
        notify({
          group: "foo",
          title: "¡Listo!",
          type: "success",
          text: "El link se copió al portapapeles."
        });
      } catch (err) {
        notify({
          group: "foo",
          title: "Error",
          type: "error",
          text: "No se pudo copiar el link."
        });
      }

      // Limpiar
      document.body.removeChild(input);
    };

    // Inicialización del componente
    onMounted(async () => {
      usuario.value = useAuthStore().usuario;
      await fetchCuentoUsuario();
      await fetchSchemaFromStrapi();
      isLoading.value = false;

      // Si hay audio en el querystring, se abre el modo editor.
      const urlParams = new URLSearchParams(window.location.search);
      const audio = urlParams.get('audio');
      if (audio) {
        estaEditando.value = true;
      }

    });

    const computedFormSchema = computed(() => formSchema.value);

    return {
      valores,
      computedFormSchema,
      handleSubmit,
      isLoading,
      estaEditando,
      propiedades,
      errorBanner,
      errorCode,
      versionSeleccionada,
      cambiarVersion,
      getContenidoCuento,
      compartirHistoria,
      copiado
    };
  },
});
</script>

<style class="scss">
.orsai-serif {
  font-family: 'IBM Plex Serif', serif;
}

.formkit-label {
  @apply font-medium text-gray-700 mb-2;
  text-transform: none;
  font-size: 0.90rem !important;
}

.cuento {

  /* Desktop (Por defecto) */
  .titulo {
    font-size: 2.5rem !important;
    font-weight: 300;
    padding-bottom: 1rem;
    margin-bottom: 0px;
    margin-bottom: 0px;

    /* Bold */
  }

  .resumen {
    font-size: 1.1rem !important;
    font-weight: 600;
    padding-bottom: 1rem;
    /* Semibold */
  }

  .tema {
    font-size: 0.8rem !important;
    text-transform: uppercase;
  }

  .contenido {
    font-size: 1.2rem !important;
    font-weight: 400;
    /* Regular */
  }

  /* Mobile */
  @media (max-width: 768px) {
    .titulo {
      font-size: 1.8rem !important;
    }

    .resumen {
      font-size: 1rem !important;
    }

    .tema {
      font-size: 1rem !important;
    }

    .contenido {
      font-size: 1rem !important;
    }
  }

}

/* Font family normal */
.font-inter {
  font-family: 'Inter', sans-serif;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
</style>
